// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {DropdownInput} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useResponsive} from '@supermove/hooks';
import {OrganizationModel} from '@supermove/models';
import {ViewStyleProp} from '@supermove/styles/types';

// App
import FieldInput from '@shared/design/components/Field/FieldInput';

const handleChangeProjectType = ({form, field, jobFormField}: any) => {
  // Clear job type when project type changes
  if (jobFormField) {
    form.setFieldValue(`${jobFormField}.jobTypeId`, undefined);
  }
};

type ProjectTypeDropdownProps = {
  organization: OrganizationModel;
  form: any;
  field: string;
  jobFormField?: string;
  style?: ViewStyleProp;
  isRequired?: boolean;
  isResponsive?: boolean;
  isDisabled?: boolean;
};

const ProjectTypeDropdown = ({
  organization,
  form,
  field,
  jobFormField,
  style,
  isRequired = true,
  isResponsive = true,
  isDisabled = false,
}: ProjectTypeDropdownProps) => {
  const responsive = useResponsive();

  return (
    <FieldInput
      {...form}
      index={0}
      component={DropdownInput}
      name={`${field}.projectTypeId`}
      label={'Project Type'}
      isRequired={isRequired}
      isResponsive={isResponsive}
      isDisabled={isDisabled}
      input={{
        options: organization.projectTypes.map((projectType: any) => ({
          label: projectType.name,
          value: Number(projectType.id),
        })),
        required: !isRequired && !_.get(form.values, `${field}.projectTypeId`),
        placeholder: 'Select Project Type',
        isSearchable: true,
        isDisabled,
        setFieldValue: form.setFieldValue,
        isPortaled: true,
        onChangeValue: (value: any) =>
          handleChangeProjectType({
            form,
            field,
            jobFormField,
          }),
        style: style || {
          flex: 1,
        },
      }}
      style={style}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectTypeDropdown.fragment = gql`
  fragment ProjectTypeDropdown on Organization {
    id
    projectTypes: projectTypesForCategory(category: "MOVE") {
      id
      name
    }
  }
`;

export default ProjectTypeDropdown;
